import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ThankYouSection from "@/components/sections/ThankYouSection";
import FounderNote from "@/components/sections/FounderNote";
import Mission from "@/components/sections/Mission";
import Programs from "@/components/sections/Programs";
import GoalTracker from "@/components/sections/GoalTracker";
import VideoReel from "@/components/sections/VideoReel";
import GetInTouch from "@/components/sections/GetInTouch";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--bone)] text-[var(--ink)]">
      <Nav />
      <Hero />
      <ThankYouSection />
      <FounderNote />
      <Mission />
      <Programs />
      <GoalTracker />
      <VideoReel />
      <GetInTouch />
      <Footer />
    </div>
  );
}
